@if (data?.action === 'add') {
  <div class="container-tab-lists kpiProductHierarchyCustom">
    <div class="inner-tcontainer-tab tab-body">
      <h3>Create Product</h3>
      <div class="new-form-style custom-mat-dialog_v2">
        <div class="tab-content">
          <form [formGroup]="form" class="internalMax">
            <div class="row">
              <div class="col-sm-12 form-group">
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>Line of Business / Asset Type</mat-label>
                    <input matInput formControlName="dimensionName" required>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 form-group">
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>Product Name (Global)</mat-label>
                    <input matInput formControlName="productDescription" required>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 10px; padding-bottom: 10px;">
              <div class="col-sm-12">
                <button mat-raised-button type="button" class="btn pull-right btn-success" [disabled]="!form.valid">
                  Save
                </button>
                <button mat-raised-button type="button" class="btn pull-right btn-default" (click)="onCancel()" style="margin-right: 10px;">
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}

@if (data?.action === 'history') {
  <div class="changelog-dialog">
    <mat-toolbar class="header heading-background">
      <div class="col-lg-9">
        @if (data?.productSelected) {
          <h5>Product Hierarchy Change History - {{data.productSelected}}</h5>
        }
        @if (data?.productMappingSelected) {
          <h5>Product Hierarchy Mapping Change History - {{data.productMappingSelected}}</h5>
        }
      </div>
      <div class="col-lg-3 search-container">
        <input class="form-control" type="text" placeholder="Search" [(ngModel)]="searchString" (keyup)="updateFilteredHistory()">
      </div>
    </mat-toolbar>
    <div class="custom_small_panelbody_fix">
      <table mat-table
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z8 mat-table-custom">
        <ng-container matColumnDef="ChangedAtUtc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>UTC Date</th>
          <td mat-cell *matCellDef="let element">
            {{element.ChangedAtUtc | date:'yyyy-MM-dd HH:mm'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="ChangedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Changed By</th>
          <td mat-cell *matCellDef="let element">
            {{element.ChangedBy}}
          </td>
        </ng-container>
        <ng-container matColumnDef="Field">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Field</th>
          <td mat-cell *matCellDef="let element">
            {{element.Field}}
          </td>
        </ng-container>
        <ng-container matColumnDef="OldValue">
          <th mat-header-cell *matHeaderCellDef>Old Value</th>
          <td mat-cell *matCellDef="let element">
            {{element.OldValue}}
          </td>
        </ng-container>
        <ng-container matColumnDef="NewValue">
          <th mat-header-cell *matHeaderCellDef>New Value</th>
          <td mat-cell *matCellDef="let element">
            {{element.NewValue}}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <br />
    <div class="button-container">
      <button mat-raised-button class="btn button-fix button-color-fix-red" (click)="onCancel()">
        <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
        Back
      </button>
    </div>
  </div>
}
